import React from "react";
import QuoteImage from "../../assets/images/about/family.png";
import about_family from "../../assets/images/about/family_about.jpeg";
export default function QuoteSection() {
  return (
    <div className="bg-[#f4e391]">
      <div className="grid xl:grid-cols-2 grid-cols-1 items-center ">
        {/* Left Side Text */}
        <div className=" w-full md:w-[73%] 2xl:w-[78%] 3xl:w-[60%] mx-auto xl:ml-20 2xl:ml-32 3xl:ml-[15rem] p-5 sm:px-8  md:p-11 xl:p-0">
          <h2
            className="md:text-[25px] text-xl sm:text-base xl:text-[36px] md:font-light text-[#29562f] leading-normal lg:leading-[54px] sm:pt-2 mb-6 font-lexend xl:pr-5 3xl:pr-10"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            At Moondew, we believe that good sleep need not come with a
            compromise. Not on health. Not on ethics. Not the truth. And
            definitely not in comfort.
          </h2>
          <p
            className="sm:text-[14px] text-base xs:text-[12px] lg:text-[20px] text-[#29562f] mb-4 font-lexend font-light 3xl:pr-10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Because when you lie down on a Moondew mattress, you’re not just
            sleeping better. You’re choosing better.
          </p>
          <p
            className="sm:text-[14px] text-base xs:text-[12px] lg:text-[20px] text-[#29562f] font-lexend font-light "
            data-aos="fade-up"
            data-aos-delay="200"
          >
            For your body. For your peace of mind. And for the planet.
          </p>
        </div>

        {/* Right Side Image */}
        <div className="">
          <img
            src={QuoteImage}
            alt="Family enjoying on mattress"
            className="w-full h-auto md:block hidden "
          />
          <img
            src={about_family}
            className="md:hidden block  w-full h-full"
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
